import React from "react";
import PropTypes from "prop-types";

import Carousel from "../../atoms/carousel";
import Icon from "../../atoms/icon";
import BigSliderSlide from "../../atoms/big-slider-slide/index";
import styles from "./styles.m.css";
import { getStoryHeadline } from "../../utils/utils";

const Slider1S = ({ stories, accentColor }) => {
  stories = stories.filter(story => story.url && (getStoryHeadline(story) || story["alternate-headline"]));
  if (stories.length === 0) {
    return null;
  }

  let slides = stories.map(story => <BigSliderSlide accentColor={accentColor} key={story.id} story={story} />);

  if (slides.length === 1) {
    return (
      <div className={`${styles["base"]}`}>
        <div className={`container`}>{slides}</div>
      </div>
    );
  }

  return (
    <div className={`${styles["base"]}`} style={accentColor && { "--accent-color": accentColor }}>
      <div className={`container`}>
        <Carousel
          options={{
            autoplay: 3000,
            type: "carousel"
          }}
          renderCenterLeftControls={({ previousSlide }) => (
            <button
              aria-label="previous slide"
              role="button"
              onClick={previousSlide}
              className={`${styles["slider-nav-button"]}`}
            >
              <Icon type={"slider-prev"} className={styles["slider-nav"]} />
            </button>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <button
              aria-label="next slide"
              role="button"
              onClick={nextSlide}
              className={`${styles["slider-nav-button"]}`}
            >
              <Icon type={"slider-next"} className={styles["slider-nav"]} />
            </button>
          )}
          renderBottomCenterControls={({ nextSlide }) => null}
        >
          {slides}
        </Carousel>
      </div>
    </div>
  );
};

Slider1S.propTypes = {
  accentColor: PropTypes.string,
  stories: PropTypes.arrayOf(BigSliderSlide.propTypes.story)
};

export default Slider1S;
